import React, { Component } from 'react';
import './Navbar.css'

class Navbar extends Component {

    handleClick = e => {
        e.preventDefault()
        this.props.resultClick()
    }

    render() {

        return (
            <div className="Navbar">
                <div className="Navbar__logo"></div>
                <h1>{this.props.title}</h1>
                <div className="Navbar__btnResults" onClick={this.handleClick}>
                    <div className="Navbar__ico"></div>
                    <h4>Resultados Finales</h4>
                </div>
            </div>
        );
    }
};

export default Navbar;